<template lang="pug">
    v-snackbar.snackbar(
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :right="x === 'right'"
        :timeout="timeout"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        :color="color"
        v-model="show"
    ) {{ text }}
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState('snackbar', [
                'top',
                'x',
                'y',
                'timeout',
                'mode',
                'color',
                'text',
            ]),
            show: {
                get() {
                    return this.$store.state.snackbar.show;
                },
                set() {
                    this.$store.dispatch('snackbar/hide');
                },
            },
        },
    };
</script>

<style lang="stylus">
    @import "../../assets/style/_variables.styl";

    .snackbar
        font-family: $body-font-family
</style>
